import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
    return (
        <>
            <header className="header__area">
                <div className="header__inner">
                    <div className="header__logo">
                        <Link to="/">
                            <img className="logo-primary" src="assets/imgs/logo/site-logo-white.png" alt="Site Logo" />
                            <img className="logo-secondary" src="assets/imgs/logo/site-logo-white-2.png" alt="Moibile Logo" />
                        </Link>
                    </div>
                    <div className="header__nav-icon">
                        <button id="open_offcanvas">
                            <img src="assets/imgs/icon/menu-white.png" alt="Menubar Icon" />
                        </button>
                    </div>
                    <div className="header__support">
                        <p>Contact Us Now <a href="tel:+918347406455">+91 8347406455</a></p>
                    </div>
                </div>

            </header>
        </>
    )
}

export default Header